function Footer() {
  return (
    <footer className="text-center text-muted">
      <small>
        Fun fact: I speak four languages, but CSS still surprises me 😄
      </small>
    </footer>
  );
}

export default Footer;
